import { render, staticRenderFns } from "./tiendas.vue?vue&type=template&id=61cb9648&scoped=true"
import script from "./tiendas.vue?vue&type=script&lang=js"
export * from "./tiendas.vue?vue&type=script&lang=js"
import style0 from "./tiendas.vue?vue&type=style&index=0&id=61cb9648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cb9648",
  null
  
)

export default component.exports